import { Button, Text } from "@chakra-ui/react";
import { UseMutateFunction } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { ReactionTypeEntity } from "../../../../services/gc/types/reactionTypeEntity";
import {
  ReactionSummaryEntity,
  Release,
  ServerSingleResponse,
} from "../../../../types";
import { useUserData } from "../../../../hooks/useUserData";
import { FUNNEL_TYPES } from "../../../../components/funnel/utils/contants";
import { FunnelContextArea } from "../../../../components/funnel/types";
import { setFunnelModalConfig } from "../../../../components/funnel/FunnelModal";

interface ReactionToggleProps {
  reactionType: ReactionTypeEntity;
  reactionSummary?: ReactionSummaryEntity;
  toggleReaction: UseMutateFunction<
    AxiosResponse<ServerSingleResponse<ReactionSummaryEntity>, any>,
    Error,
    number,
    AxiosResponse<ServerSingleResponse<Release>, any> | undefined
  >;
}
export function ReactionToggle({
  reactionType,
  reactionSummary,
  toggleReaction,
}: ReactionToggleProps) {
  const { userData } = useUserData();

  return (
    <Button
      variant="reactionToggle"
      size="thin"
      gap="14px"
      isActive={reactionSummary?.is_clicked}
      onClick={() => {
        if (userData) {
          toggleReaction(reactionType.id);
        } else {
          setFunnelModalConfig({
            type: FUNNEL_TYPES.signup,
            context: {
              modalContext: FunnelContextArea.reaction,
            },
            options: {
              onSuccess: () => toggleReaction(reactionType.id),
            },
          });
        }
      }}
    >
      <span dangerouslySetInnerHTML={{ __html: reactionType.display_name }} />
      <Text fontWeight="bold">{reactionSummary?.value ?? 0}</Text>
    </Button>
  );
}
